import type { Template } from "@/types";

export const LA_07_H4_V3: Template[] = [
  
    {
        id: "la-07-h4v3-01",
        name: "LA 01 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 92, y: 87, width: 242, height: 151, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 246, width: 242, height: 151, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 87, width: 241, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 246, width: 241, height: 151, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 37, width: 306, height: 408, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1101, y: 37, width: 140, height: 200, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1101, y: 245, width: 140, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-02",
        name: "LA 02 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 92, y: 38, width: 491, height: 298, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 343, width: 159, height: 103, rotation: 0, imageRotation: 0 },
            { id: "3", x: 259, y: 343, width: 158, height: 103, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 343, width: 158, height: 103, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 38, width: 306, height: 408, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1101, y: 245, width: 140, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1101, y: 37, width: 140, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-03",
        name: "LA 03 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 133, y: 49, width: 410, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 308, width: 202, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 308, width: 201, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 49, width: 396, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 816, y: 265, width: 127, height: 170, rotation: 0, imageRotation: 0 },
            { id: "6", x: 951, y: 265, width: 127, height: 170, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1086, y: 265, width: 126, height: 170, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-04",
        name: "LA 04 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 132, y: 48, width: 133, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 132, y: 245, width: 133, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 272, y: 48, width: 271, height: 386, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 48, width: 480, height: 268, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 324, width: 155, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 936, y: 324, width: 155, height: 110, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1098, y: 324, width: 156, height: 110, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-05",
        name: "LA 05 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 133, y: 182, width: 410, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 48, width: 202, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 48, width: 201, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 49, width: 396, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 816, y: 265, width: 127, height: 170, rotation: 0, imageRotation: 0 },
            { id: "6", x: 951, y: 265, width: 127, height: 170, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1086, y: 265, width: 126, height: 170, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-06",
        name: "LA 06 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 98, y: 48, width: 480, height: 268, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 324, width: 156, height: 110, rotation: 0, imageRotation: 0 },
            { id: "3", x: 261, y: 324, width: 155, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 423, y: 324, width: 155, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 809, y: 48, width: 271, height: 386, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1087, y: 48, width: 133, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1087, y: 245, width: 133, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-07",
        name: "LA 07 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 43, y: 49, width: 589, height: 385, rotation: 0, imageRotation: 0 },
            { id: "2", x: 719, y: 49, width: 194, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 180, width: 194, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 312, width: 194, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 921, y: 49, width: 258, height: 386, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1187, y: 49, width: 122, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1187, y: 246, width: 122, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-08",
        name: "LA 08 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 57, width: 247, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 255, y: 57, width: 285, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 245, width: 285, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 547, y: 57, width: 258, height: 369, rotation: 0, imageRotation: 0 },
            { id: "5", x: 813, y: 57, width: 285, height: 181, rotation: 0, imageRotation: 0 },
            { id: "6", x: 813, y: 245, width: 285, height: 181, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1105, y: 57, width: 247, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-09",
        name: "LA 09 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 57, width: 285, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 245, width: 285, height: 182, rotation: 0, imageRotation: 0 },          
            { id: "3", x: 292, y: 57, width: 252, height: 370, rotation: 0, imageRotation: 0 },
            { id: "4", x: 551, y: 57, width: 251, height: 370, rotation: 0, imageRotation: 0 },
            { id: "5", x: 809, y: 57, width: 251, height: 370, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1067, y: 57, width: 285, height: 181, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1067, y: 245, width: 285, height: 182, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-07-h4v3-10",
        name: "LA 10 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h4_v3_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 107, width: 409, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 417, y: 107, width: 104, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 246, width: 104, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 528, y: 107, width: 214, height: 270, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 107, width: 187, height: 132, rotation: 0, imageRotation: 0 },
            { id: "6", x: 750, y: 246, width: 187, height: 131, rotation: 0, imageRotation: 0 },
            { id: "7", x: 944, y: 107, width: 408, height: 270, rotation: 0, imageRotation: 0 }
        ],
    }
];